import {LOCAL_STORAGE_ACCESS_TOKEN_KEY, REFRESH_PATH, refreshToken,} from './auth';
import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const axiosClient = axios.create();

const refreshAndRetryQueue = [];

let isRefreshing = false;

axiosClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response && error.response.status === 401) {
            if (!isRefreshing) {
                isRefreshing = true;
                await refreshToken();
                error.config.headers.Authorization = buildAuthorizationHeader();

                refreshAndRetryQueue.forEach(({config, resolve, reject}) => {
                    axiosClient
                        .request(config)
                        .then((response) => resolve(response))
                        .catch((err) => reject(err));
                });

                refreshAndRetryQueue.length = 0;
                return axiosClient(originalRequest);
            }

            if (isRefreshing && error.config?.url?.includes(REFRESH_PATH)) {
                isRefreshing = false;
                logout();
            } else {
                return new Promise((resolve, reject) => {
                    refreshAndRetryQueue.push({config: originalRequest, resolve, reject});
                });
            }
        }

        return Promise.reject(error);
    },
);

const del = async (url, useAuth = true) => {
    return request(url, {method: 'DELETE', headers: {}}, useAuth);
};

const get = async (url, useAuth = true) => {
    return request(url, {method: 'GET', headers: {}}, useAuth);
};

const post = async (url, payload, useAuth = true) => {
    const options = {
        method: 'POST',
        data: JSON.stringify(payload),
        headers: {
            'Content-Type': 'application/json',
        },
    };

    return request(url, options, useAuth);
};

const put = async (url, payload, useAuth = true) => {
    const options = {
        method: 'PUT',
        data: JSON.stringify(payload),
        headers: {
            'Content-Type': 'application/json',
        },
    };

    return request(url, options, useAuth);
};

const patch = async (url, payload, useAuth = true) => {
    const options = {
        method: 'PATCH',
        data: JSON.stringify(payload),
        headers: {
            'Content-Type': 'application/json',
        },
    };

    return request(url, options, useAuth);
};

const request = async (url, options, useAuth = true) => {
    if (useAuth) {
        options.headers.Authorization = buildAuthorizationHeader();
    }

    return axiosClient(backendUrl + url, options).then(response => response.data);
};

function buildAuthorizationHeader() {
    return `Bearer ${localStorage.getItem(LOCAL_STORAGE_ACCESS_TOKEN_KEY)}`;
}

function logout() {
    localStorage.clear()
    window.location.href = "/login";
}

export {axiosClient, get, post, put, patch, del, request, logout};